<template>
  <div>
    <CRow>
      <CCol sm="12">
        <SalesTable
          :items="sales"
          :pagination="salesPagination"
          hover
          striped
          border
          small
          fixed
          caption="Registro de Ventas"
          @refresh="refreshItems"
          :permissions="permissions"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import SalesTable from '../../components/sales/SalesTable.vue'
import ws from '../../services/sales';
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'Sales',
  components: { SalesTable },
  data: function () {
		return {
            sales: [],
    salesPagination: {},
            permissions: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      const normalized = this.normalizePayload(response);
      this.sales = normalized.items;
      this.salesPagination = normalized.pagination;
    }

    let response2 = await account_ws.getInfo(); 

    if(response2.type == "success"){
      this.permissions = response2.data.user.permissions;
    }

    this.loaded();
  },
  methods: {
    normalizePayload (payload) {
      if (!payload) {
        return { items: [], pagination: {} };
      }

      const items = Array.isArray(payload.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : [];

      return {
        items,
        pagination: payload.pagination || {}
      };
    },
    refreshItems (response){
      this.loading();
      const normalized = this.normalizePayload(response);
      this.sales = normalized.items;
      this.salesPagination = normalized.pagination;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
